import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("i", {
    class: _normalizeClass(["iconfont", `icon-${_ctx.name}`]),
    style: _normalizeStyle(_ctx.style)
  }, null, 6);
}